module.exports = __webpack_public_path__ + "img/stats-wave.b6368ebd.svg";